import { TextField } from "@mui/material";
import { useCallback } from "react";

export type TruxSimpleTextFieldProps<T> = {
  value: string,
  label?: string,
  disabled?: boolean,
  onChange: (t: string) => void
}

export default function TruxSimpleTextField<T>({ value, onChange, label, disabled }: TruxSimpleTextFieldProps<T>) {
  const fieldOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const val = e.target.value as any;

    onChange(val);
  }, [onChange]);

  return <TextField size="small" autoComplete="off" disabled={disabled} label={label} sx={{ display: "flex" }} value={value} onChange={fieldOnChange} />
}